<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">GF Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / GF Settingss</span>
        </h4>
        
        <div class="ibox mt-4">
            <div class="ibox-content">
        
                <form  enctype="multipart/form-data" @submit.stop.prevent="formSubmit">
                    <div v-if="$acl['company/savegfsettings'] > 0" id="gf_settings">
                                {{successmsg}}
                        <div class="clearfix row no-margin">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            GF General Settings
                                        </div>
                                        <div class="approve-level-description">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <div class="clearfix px-0">
                                            <div class="clearfix">                                                        
                                                
                                                <div class=" row mx-1 mt-3 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-md-9 px-0 salary-heads">Enable Gratuity Fund <b-icon class="" icon="info-circle" title="Enable Gratuity Fund" v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right"><toggle-button v-model="fdata.enable_gratuity_fund" key="enable_gratuity_fund" value="true" :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" /></div>
                                                </div>

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-4">
                                                    
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_financial_year_end_month-group" label="GF Financial Year End Month" label-for="gf_financial_year_end_month" class="required-field">
                                                            <b-form-select name="gf_financial_year_end_month" class='form-control' v-model="fdata.gf_financial_year_end_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('gf_financial_year_end_month')" aria-describedby="gf_financial_year_end_month-feedback" data-vv-as="Status">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_financial_year_end_month-feedback"> {{ veeErrors.first('gf_financial_year_end_month') }} </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>                                                           

                                                </div>                                                

                                            </div>
                                            <div class="clearfix rounded px-0 service_length_settings mt-3">
                                                                                    
                                                <div class="pb-3 row">
                                                    <div class="col-md-6">
                                                        <p class="service_length_title salary-heads">Service length format settings <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                                        <div class="mt-3">
                                                            <div class="toggle_button_tax first salary-heads d-flex"  >
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Years and Months</div>
                                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio" v-model="fdata.company_gf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="yes"> 
                                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                                                </div>
                                                                
                                                            </div>
                                                            
                                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Only Months</div>
                                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio" v-model="fdata.company_gf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no" > 
                                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                            <div data-v-25adc6c0="" class="v-switch-button"></div></div> <!----></label>
                                                                </div>
                                                                
                                                            </div>
                                                            
                                                        </div>
                                                    </div>                                                            

                                                    <div class="ibox no-shadow border-2 mt-4 gray-border col-md-6">
                                                        <b-overlay  rounded="sm"  class='payslip-designer-overlay'>
                                                            <div class="clearfix service_format_overview mb-3 mt-2 mx-auto px-3 py-4">
                                                                <div class ="number_format_header_title font-medium" style="font-size: 18px;color: #747474;">Sample Output</div>
                                                                <table style="width: 99%;" class="d-table">
                                                                
                                                                    <template v-if="fdata.company_gf_service_month=='no'">
                                                                        <tr> 
                                                                            <td class = 'service_format_overview_td_label py-2 text-secondary border-bottom' ><template >Service Period</template></td>  <td class = 'service_format_overview_td_value border-bottom py-2'><template >47 Month(s)</template></td>
                                                                        </tr> 
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label text-secondary py-2'><template >Membership Period</template></td>  <td  class = 'service_format_overview_td_value py-2'  ><template >11 Month(s)</template></td>
                                                                        </tr> 
                                                                    </template>
                                                                    <template v-if="fdata.company_gf_service_month=='yes'">
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label py-2 text-secondary border-bottom'><template >Service Period</template></td>  <td class = 'service_format_overview_td_value py-2 border-bottom'  ><template >3 Year(s) 11 Month(s)</template></td>
                                                                        </tr> 
                                                                        <tr> 
                                                                            <td  class = 'service_format_overview_td_label text-secondary py-2'><template >Membership Period</template></td>  <td class = 'service_format_overview_td_value py-2' ><template >0 Year(s) 11 Month(s)</template></td>
                                                                        </tr> 
                                                                    </template> 
                                                    
                                                                </table>   
                                                            </div>
                                                        </b-overlay>
                                                    </div>
                                                </div>

                                                <div class=" row mx-1 mb-3 py-2 w-100 align-items-center no-margin border-bottom">
                                                    <div class="col-md-9 px-0 salary-heads">Migration Support <b-icon class="" icon="info-circle" title="Enable Migration Support" v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right"><toggle-button v-model="fdata.gf_migration_support" key="migration_support" value="true" :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" /></div>
                                                </div>

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-0" v-if="fdata.gf_migration_support">
                                                    
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_migration_month-group" label="Month" label-for="gf_migration_month" class="required-field">
                                                            <b-form-select name="gf_migration_month" class='form-control' v-model="fdata.gf_migration_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('gf_migration_month')" aria-describedby="gf_migration_month-feedback" data-vv-as="Status">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_migration_month-feedback"> {{ veeErrors.first('gf_migration_month') }} </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>  

                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <b-form-group id="gf_migration_year-group" label="Year" label-for="gf_migration_year" class="required-field">
                                                            <b-form-select name="gf_migration_year" class='form-control' v-model="fdata.gf_migration_year" v-validate="{ required: true }" :state="validateState('gf_migration_year')" aria-describedby="gf_migration_year-feedback" data-vv-as="Status">
                                                                <option v-for="year in yearsList" :key="year" :value="year">
                                                                    {{ year }}
                                                                </option>
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="gf_migration_year-feedback"> {{ veeErrors.first('gf_migration_year') }} </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>  

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-sm-12 text-right">
                                                        <button type="submit" class="btn btn-primary btn-md">SAVE</button>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                        <div class="clearfix row no-margin pt-2">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            GF Contribution Process Policy Selection
                                        </div>
                                        <div class="approve-level-description">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                        </div>
                                    </div>
                                    <div  class="col-8 approve-level-content">
                                        <p class="service_length_title salary-heads">GF Contribution Process Policy <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                        <div class="">
                                            
                                            <b-form-group id="contribution_policy-group" label="Select a Contribution Policy" label-for="contribution_policy" class="required-field">
                                                <b-form-select name="contribution_policy" class='form-control' v-model="fdata.gf_contribution_policy" :options="contribution_policy_list" v-validate="{ required: true }" :state="validateState('contribution_policy')" aria-describedby="contribution_policy-feedback" data-vv-as="Contribution Policy">
                                                </b-form-select>
                                                <b-form-invalid-feedback id="contribution_policy-feedback"> {{ veeErrors.first('contribution_policy') }} </b-form-invalid-feedback>
                                            </b-form-group>

                                        </div>
                                        <div class="row mx-1 py-2 w-100 align-items-center no-margin">
                                            <div class="col-sm-12 text-right">
                                                <button type="submit" class="btn btn-primary btn-md">SAVE</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix row no-margin">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            GF Reasons for Separation List
                                        </div>
                                        <div class="approve-level-description">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        
                                        <gf-reasons-for-separation></gf-reasons-for-separation>
                                                                                                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                                                
                    </div>            
                </form>
            </div> 
        </div>
    </div>
</template>
<style scoped>
.w-45{width: 45% !important;}
.w-60{width: 60% !important;}
</style>
<script>

    export default{
        props: ['companyid','pageurl'],
        mounted() {
        }, 
        data(){
            return {  
                
                company_unreg_pf: '',
                company_reg_pf: '',
                pf_on: 1,
               
                m_lists : [{value: '1', text: 'January'},{value: '2', text: 'February'},{value: '3', text: 'March'},{value: '4', text: 'April'},{value: '5', text: 'May'},{value: '6', text: 'June'},{value: '7', text: 'July'},{value: '8', text: 'August'},{value: '9', text: 'September'},{value: '10', text: 'October'},{value: '11', text: 'November'},{value: '12', text: 'December'}],
               
                selection_data: [],
                pgurl:this.$api_url,               
                successmsg:'',

                settings_pf_type: 0,
                showoverlay:true,
 
                movenext : false,

                length: 2,
                pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

             
                fdata: { 
                    enable_gratuity_fund: true,
                    gf_migration_support: true,
                    gf_financial_year_end_month: 6,
                    gf_migration_month: 1,
                    gf_migration_year: new Date().getFullYear(),
                    company_gf_service_month: 'no',
                    gf_contribution_policy: 1,
                },

              
                status: [
                   
                    { value: "1", text: "Enabled" },
                    { value: "2", text: "Disabled" },                    
                ],
              
                length_options: 
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                temp_length:20,

                search: '',

                contribution_policy_list: [
                    { value: 1, text: "Direct Balance Contribution" },
                    { value: 2, text: "Dynamic Proportion Based Contribution" },
                    { value: 3, text: "Actuarial Amount Based Contribution" },
                    { value: 4, text: "Actuarial Rate Based Contribution" },                                        
                ],

                yearsList: [],

                company_id: this.companyid,
                company_gf_settings: [],
            }
        },
        methods:{

            generateYears() {
                const startYear = 2001;
                const currentYear = new Date().getFullYear();
                const years = [];

                for (let year = currentYear; year >= startYear; year--) {
                    years.push(year);
                }

                return years;
            },

            // methods goes here..
           
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                    //conseole.log('hererererre');
                    this.company_unreg_pf = null;
                    this.company_reg_pf = null;
                    this.pf_on = 0;
            },
            
            scrollToTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });  
            },

            getCompanyGFSettings: function()
            {      
                let currentObj = this;
                let formData = new FormData();
                axios.post(this.$api_url + '/gf/companygfsettings', formData)
                .then(function (response) 
                { 
                    if(response.data.data){
                        this.company_gf_settings = response.data.data;
                        if(this.company_gf_settings.gf_year_end.opt_value == 0 || this.company_gf_settings.gf_year_end.opt_value == 'null'){
                            this.fdata.gf_financial_year_end_month = 6;
                        }else{
                            this.fdata.gf_financial_year_end_month = this.company_gf_settings.gf_year_end.opt_value;
                        }
                        // (this.company_gf_settings.gf_year_end.opt_value == 'true') ? true : false
                        this.fdata.company_gf_service_month = (parseInt(this.company_gf_settings.gf_service_month_format.opt_value) == 1) ? 'yes' : 'no';
                        this.fdata.enable_gratuity_fund = this.company_gf_settings.gf_enabled.opt_value == 'true' ? true : false;
                        this.fdata.gf_migration_support = this.company_gf_settings.gf_migration_support.opt_value == 'true' ? true : false;
                        this.fdata.gf_migration_month = parseInt(this.company_gf_settings.gf_migration_month.opt_value);
                        this.fdata.gf_migration_year = parseInt(this.company_gf_settings.gf_migration_year.opt_value);
                        this.fdata.gf_contribution_policy = parseInt(this.company_gf_settings.gf_contribution_policy.opt_value);
                        if(this.company_gf_settings.gf_contribution_policy.opt_value == 0 || this.company_gf_settings.gf_contribution_policy.opt_value == 'null'){
                            this.fdata.gf_contribution_policy = 1;
                        }else{
                            this.fdata.gf_contribution_policy = this.company_gf_settings.gf_contribution_policy.opt_value;
                        }
                     
                    }
                    //this.validateState();
                }.bind(this));
            },

            onToggleChange(field_id, event) {                // added event as second arg
                let value = event.value;  
                this.selection_data[field_id] = (value == true) ? 1: 0;
            },
            formSubmit(e) 
            {                
                //console.log('here');
                e.preventDefault();
                
                let formData = new FormData(); 
                 
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let gf_service_month_format = (this.fdata.company_gf_service_month == 'no') ? 0:1;                
                
                formData.append('company_id', this.company_id); 
                formData.append('company_gf_status', this.fdata.enable_gratuity_fund);
                formData.append('gf_migration_support', this.fdata.gf_migration_support);
                formData.append('gf_financial_year_end_month', this.fdata.gf_financial_year_end_month);
                formData.append('gf_service_month_format', gf_service_month_format);
                formData.append('gf_migration_month', this.fdata.gf_migration_month);
                formData.append('gf_migration_year', this.fdata.gf_migration_year);
                formData.append('gf_contribution_policy', this.fdata.gf_contribution_policy);
                
                axios.post(this.$api_url + '/gf/savegfsettings', formData, config)
                .then(function (response) 
                {               
                    if(response.data.data){
                        this.getCompanyGFSettings();
                        this.$bvToast.toast('GF Setttings saved', {title: 'Success',variant: 'success',solid: true});
                    }else{
                        this.$bvToast.toast('An error occurred, please try again later', {title: 'Error!',variant: 'danger',solid: true});  
                    }
                }.bind(this))
                .catch(function (error) 
                {
                    currentObj.$bvToast.toast(error, {title: 'Error!',variant: 'danger',solid: true});
                });
                
            },

            getcompany: function()
            {
                let formData = new FormData();
                axios.post(this.$api_url + '/company/getcompany', formData)
                .then(function (response) 
                {     
                    this.company_id = response.data;
                    
                    if(this.company_id > 0){
                        this.getCompanyGFSettings();
                    }
                }.bind(this));
            },
        },
        created: function(){
            this.yearsList = this.generateYears();
            this.getcompany();
        }
    }
</script>

<style scoped>
.trz_service_button
{
	display: inline-block;
	vertical-align: top;
    padding-left: 0;
}
.service_length_title[data-v-83ba1f78] {
	margin-top: 33px;
	margin-bottom: 10px;
}
.trz_service_button .v-switch-button {
    transform: translate3d(3px, 3px, 0px);
	width: 16px;
	height: 16px;
	transition: transform 300ms ease 0s;
}
.toggle_button_tax {
	margin-bottom: 10px;
}
.service_length_settings .toggle_button_tax {
	padding: 10px 0 10px 0;
	margin: 0;
}
.toggle_button_tax.first {
	border-bottom: 1px solid #dee2e6;
}
.trz_service_button.tax_toggle {
	float: right;
}
.trz_service_button.px-0.tax_toggle {
	max-width: 50px;
}
.service_format_overview {
	margin-top: 35px;
	margin-left: 15px !important;
}
.service_format_overview_td_label
{
    text-align:left !important;
    font-size: 16px !important;
    width:45% !important; 
}
.service_format_overview_td_value
{
    text-align:right !important;
    font-size: 16px !important;
    width:65% !important;
    color: #004242;
}
.number_format_header_title {
	text-align: center;
	margin-bottom: 10px;
}
.service_format_overview {
	padding: 10px 10px !important;
}
#pf_loan_applicable_percent {
	display: block !important;
}


</style>
